module.exports = __webpack_public_path__ + "static/weronika-af8473b6f9785a736ff1ddfcb490adb1.png";